import cabine from '../../../services/cabineApi';
import { gotErrorFromApi } from '../../../utils/api';
import {
  getDashboardFromApi,
  gotDashboardFromApi,
} from '../../duck/legado/dashboardApp';
import { SendLoginTokenAuth } from '../tokens';

function getDashboard() {
  return (dispatch: any) => {
    dispatch(getDashboardFromApi());
    cabine
      .get('/v1/legado/dashboard', SendLoginTokenAuth())
      .then((response: any) => {
        dispatch(gotDashboardFromApi(response.data.dashboard));
      })
      .catch((error: any) => {
        gotErrorFromApi(error, dispatch);
      });
  };
}

export default getDashboard;
